module.exports = __webpack_public_path__ + "nz.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/nz.svg
// module id = 999
// module chunks = 0